interface SettingInterface {
    key: string;
    value: string;
}

class Setting implements SettingInterface {
    static readonly MESSAGE_IP_EXPIRE_SCHEMA: string  = 'message_ip_expire_schema';

    key: string;
    value: string;
}

class ExpireSchema {
    c: number;
    e: number;
}

export {
    Setting,
    SettingInterface,
    ExpireSchema
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/bases/proxy/settings/api.models.ts